import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import OrderSummary from "../components/Ordersummary";
import PaymentModal from "../components/PaymentModal";
import OrdersTable from "../components/OrdersTable";
import OrdersCards from "../components/OrdersCards";
import { getOrdersByUserId } from "../actions/ordersActions";
import "../styles/orders.css";
import "../styles/skeletons.css";
import "../styles/paymentmodal.css";
import AccountLayout from "../components/AccountLayout";
import { OrdersListSkeleton } from "../components/HomeSkeletons";

const OrdersPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const { orders = [], loading, error } = useSelector((state) => state.orders);

  // Payment modal state
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  // Check screen size
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/signin");
    } else if (user?.user_id) {
      dispatch(getOrdersByUserId(user.user_id));
    }
  }, [dispatch, isAuthenticated, navigate, user]);

  const handlePayNowClick = (order, event) => {
    event.stopPropagation(); // Prevent triggering the row click
    if (order.payment_status !== "Paid") {
      setSelectedOrder(order);
      setIsPaymentModalOpen(true);
    } else {
      navigate(`/orders/${order.order_id}`);
    }
  };

  const handlePaymentModalClose = () => {
    setIsPaymentModalOpen(false);
    setSelectedOrder(null);
  };

  const handlePaymentSuccess = (paymentData) => {
    // Optionally refresh orders or show success message
    console.log("Payment initiated successfully:", paymentData);
    // You can dispatch an action to refresh orders here if needed
    // dispatch(getOrdersByUserId(user.user_id));
  };

  useEffect(() => {
    document.title = "My Orders";
  }, []);

  return (
    <div className="myaccount-container">
      <AccountLayout />
      <div className="orders-container">
        <h2 className="orders-title">My Orders</h2>
        {error && <p className="error-message">{error}</p>}
        {loading && <OrdersListSkeleton />}
        {!loading && orders.length === 0 && (
          <p className="no-orders-message">You have no orders.</p>
        )}
        {!loading && orders.length > 0 && (
          <div className="orders-list">
            {isMobile ? (
              <OrdersCards orders={orders} onPayNowClick={handlePayNowClick} />
            ) : (
              <OrdersTable orders={orders} onPayNowClick={handlePayNowClick} />
            )}
          </div>
        )}
        {!loading && orders.length > 0 && <OrderSummary orders={orders} />}
      </div>

      {/* Payment Modal */}
      <PaymentModal
        isOpen={isPaymentModalOpen}
        onClose={handlePaymentModalClose}
        order={selectedOrder}
        onPaymentSuccess={handlePaymentSuccess}
      />
    </div>
  );
};

export default OrdersPage;
